/**
 * What a scanned lot label says. Labels printed by FactreeTech carry
 * `LOT:<id>` — the lot's id, since codes are optional and not unique. A code
 * typed into the scanner's manual box, or read off an older label, is matched
 * against lot codes instead.
 */
export type LotScan = { lotId: number } | { code: string };

export function parseLotScan(raw: string): LotScan | null {
  const text = raw.trim();
  if (!text) return null;
  const m = /^LOT:(\d+)$/i.exec(text);
  if (m) return { lotId: Number(m[1]) };
  return { code: text };
}

/** Does a lot (id and optional code) answer to this scan? */
export function scanMatches(scan: LotScan, lot: { id: number; code: string | null | undefined }): boolean {
  if ('lotId' in scan) return scan.lotId === lot.id;
  return !!lot.code && lot.code.trim().toLowerCase() === scan.code.toLowerCase();
}
